var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhitea2292549(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 20,
    viewBox: "0 0 84 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8167 0C15.9833 0 11.7833 4.08333 11.7833 9.8C11.7833 15.5167 15.8667 19.7167 21.5833 19.7167C25.55 19.7167 28.4667 18.2 30.3333 15.1667L26.0167 13.1833C25.4333 14.35 23.6833 15.2833 21.7 15.2833C19.0167 15.2833 17.3833 14 16.9167 11.4333H31.15C31.15 11.4333 31.2667 10.7333 31.2667 9.91667C31.2667 4.08333 27.4167 0 21.8167 0ZM17.0333 7.7C17.6167 5.36667 19.25 4.2 21.8167 4.2C24.3833 4.2 26.1333 5.6 26.25 7.7H17.0333ZM42.7 13.5333L37.8 0.7H31.9667L39.7833 19.0167H45.5L53.3167 0.7H47.7167L42.7 13.5333ZM56.1167 0.7H61.1333V19.0167H56.1167V0.7ZM77 9.8L83.65 0.7H77.7L73.9667 6.06667L70.2333 0.7H64.1667L70.8167 9.8L63.8167 19.0167H69.7667L73.85 13.4167L77.9333 19.0167H84L77 9.8ZM5.01667 19.0167H0V0.583333H12.0167L10.15 5.01667H5.01667V19.0167Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 19.8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhitea2292549);
export default __webpack_public_path__ + "static/media/logo-white.a2292549.02b37cefbad5c8e8f360c59c790b8ccd.svg";
export { ForwardRef as ReactComponent };